var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppIconPlaceholder = function SvgAppIconPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10674_31519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#3A3A3C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10674_31519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#64B1FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    rx: 5,
    stroke: "#F2F2F7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 9,
    y: 9,
    width: 10,
    height: 10,
    rx: 5,
    stroke: "#F2F2F7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1421 7L6.99995 21.1421",
    stroke: "#F2F2F7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
};
export { SvgAppIconPlaceholder as ReactComponent };
export default __webpack_public_path__ + "app-icon-placeholder.svg";